IntlPolyfill.__addLocaleData({
  locale: "th",
  date: {
    ca: ["gregory", "buddhist", "chinese", "coptic", "dangi", "ethioaa", "ethiopic", "generic", "hebrew", "indian", "islamic", "islamicc", "japanese", "persian", "roc"],
    hourNo0: true,
    hour12: false,
    formats: {
      short: "{1} {0}",
      medium: "{1} {0}",
      full: "{1} {0}",
      long: "{1} {0}",
      availableFormats: {
        "d": "d",
        "E": "ccc",
        Ed: "E d",
        Ehm: "E h:mm a",
        EHm: "E HH:mm น.",
        Ehms: "E h:mm:ss a",
        EHms: "E HH:mm:ss",
        Gy: "G y",
        GyMMM: "MMM G y",
        GyMMMd: "d MMM G y",
        GyMMMEd: "E d MMM G y",
        GyMMMEEEEd: "EEEEที่ d MMM G y",
        "h": "h a",
        "H": "HH",
        hm: "h:mm a",
        Hm: "HH:mm น.",
        hms: "h:mm:ss a",
        Hms: "HH:mm:ss",
        hmsv: "h:mm:ss a v",
        Hmsv: "HH:mm:ss v",
        hmv: "h:mm a v",
        Hmv: "HH:mm v",
        "M": "L",
        Md: "d/M",
        MEd: "E d/M",
        MMM: "LLL",
        MMMd: "d MMM",
        MMMEd: "E d MMM",
        MMMEEEEd: "EEEEที่ d MMM",
        MMMMd: "d MMMM",
        MMMMEd: "E d MMMM",
        MMMMEEEEd: "EEEEที่ d MMMM",
        mmss: "mm:ss",
        ms: "mm:ss",
        "y": "y",
        yM: "M/y",
        yMd: "d/M/y",
        yMEd: "E d/M/y",
        yMMM: "MMM y",
        yMMMd: "d MMM y",
        yMMMEd: "E d MMM y",
        yMMMEEEEd: "EEEEที่ d MMM y",
        yMMMM: "MMMM G y",
        yMMMMd: "d MMMM G y",
        yMMMMEd: "E d MMMM G y",
        yMMMMEEEEd: "EEEEที่ d MMMM G y",
        yQQQ: "QQQ y",
        yQQQQ: "QQQQ G y"
      },
      dateFormats: {
        yMMMMEEEEd: "EEEEที่ d MMMM G y",
        yMMMMd: "d MMMM G y",
        yMMMd: "d MMM y",
        yMd: "d/M/yy"
      },
      timeFormats: {
        hmmsszzzz: "H นาฬิกา mm นาที ss วินาที zzzz",
        hmsz: "H นาฬิกา mm นาที ss วินาที z",
        hms: "HH:mm:ss",
        hm: "HH:mm"
      }
    },
    calendars: {
      buddhist: {
        months: {
          narrow: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
          short: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
          long: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"]
        },
        days: {
          narrow: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
          short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          long: ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"]
        },
        eras: {
          narrow: ["พ.ศ."],
          short: ["พ.ศ."],
          long: ["พุทธศักราช"]
        },
        dayPeriods: {
          am: "ก่อนเที่ยง",
          pm: "หลังเที่ยง"
        }
      },
      chinese: {
        months: {
          narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
          short: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
          long: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]
        },
        days: {
          narrow: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
          short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          long: ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"]
        },
        dayPeriods: {
          am: "ก่อนเที่ยง",
          pm: "หลังเที่ยง"
        }
      },
      coptic: {
        months: {
          narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13"],
          short: ["เทาท์", "บาบา", "ฮาเทอร์", "เคียฟ", "โทบา", "อัมเชอร์", "บารัมฮัท", "บาราเมาดา", "บาชันส์", "พาโอนา", "อีเปป", "เมสรา", "นาซี"],
          long: ["เทาท์", "บาบา", "ฮาเทอร์", "เคียฟ", "โทบา", "อัมเชอร์", "บารัมฮัท", "บาราเมาดา", "บาชันส์", "พาโอนา", "อีเปป", "เมสรา", "นาซี"]
        },
        days: {
          narrow: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
          short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          long: ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"]
        },
        eras: {
          narrow: ["ERA0", "ERA1"],
          short: ["ERA0", "ERA1"],
          long: ["ERA0", "ERA1"]
        },
        dayPeriods: {
          am: "ก่อนเที่ยง",
          pm: "หลังเที่ยง"
        }
      },
      dangi: {
        months: {
          narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
          short: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
          long: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]
        },
        days: {
          narrow: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
          short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          long: ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"]
        },
        dayPeriods: {
          am: "ก่อนเที่ยง",
          pm: "หลังเที่ยง"
        }
      },
      ethiopic: {
        months: {
          narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13"],
          short: ["เมสเคอเรม", "เตเกมท", "เฮดาร์", "ทาฮ์ซัส", "เทอร์", "เยคาทิท", "เมกาบิต", "เมียเซีย", "เจนบอต", "เซเน", "ฮัมเล", "เนแฮซ", "พากูเมน"],
          long: ["เมสเคอเรม", "เตเกมท", "เฮดาร์", "ทาฮ์ซัส", "เทอร์", "เยคาทิท", "เมกาบิต", "เมียเซีย", "เจนบอต", "เซเน", "ฮัมเล", "เนแฮซ", "พากูเมน"]
        },
        days: {
          narrow: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
          short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          long: ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"]
        },
        eras: {
          narrow: ["ERA0", "ERA1"],
          short: ["ERA0", "ERA1"],
          long: ["ERA0", "ERA1"]
        },
        dayPeriods: {
          am: "ก่อนเที่ยง",
          pm: "หลังเที่ยง"
        }
      },
      ethioaa: {
        months: {
          narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13"],
          short: ["เมสเคอเรม", "เตเกมท", "เฮดาร์", "ทาฮ์ซัส", "เทอร์", "เยคาทิท", "เมกาบิต", "เมียเซีย", "เจนบอต", "เซเน", "ฮัมเล", "เนแฮซ", "พากูเมน"],
          long: ["เมสเคอเรม", "เตเกมท", "เฮดาร์", "ทาฮ์ซัส", "เทอร์", "เยคาทิท", "เมกาบิต", "เมียเซีย", "เจนบอต", "เซเน", "ฮัมเล", "เนแฮซ", "พากูเมน"]
        },
        days: {
          narrow: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
          short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          long: ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"]
        },
        eras: {
          narrow: ["ERA0"],
          short: ["ERA0"],
          long: ["ERA0"]
        },
        dayPeriods: {
          am: "ก่อนเที่ยง",
          pm: "หลังเที่ยง"
        }
      },
      generic: {
        months: {
          narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
          short: ["M01", "M02", "M03", "M04", "M05", "M06", "M07", "M08", "M09", "M10", "M11", "M12"],
          long: ["M01", "M02", "M03", "M04", "M05", "M06", "M07", "M08", "M09", "M10", "M11", "M12"]
        },
        days: {
          narrow: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
          short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          long: ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"]
        },
        eras: {
          narrow: ["ERA0", "ERA1"],
          short: ["ERA0", "ERA1"],
          long: ["ERA0", "ERA1"]
        },
        dayPeriods: {
          am: "ก่อนเที่ยง",
          pm: "หลังเที่ยง"
        }
      },
      gregory: {
        months: {
          narrow: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
          short: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
          long: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"]
        },
        days: {
          narrow: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
          short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          long: ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"]
        },
        eras: {
          narrow: ["ก่อน ค.ศ.", "ค.ศ.", "ก.ส.ศ.", "ส.ศ."],
          short: ["ปีก่อน ค.ศ.", "ค.ศ.", "ก.ส.ศ.", "ส.ศ."],
          long: ["ปีก่อนคริสต์ศักราช", "คริสต์ศักราช", "ก่อนสามัญศักราช", "สามัญศักราช"]
        },
        dayPeriods: {
          am: "ก่อนเที่ยง",
          pm: "หลังเที่ยง"
        }
      },
      hebrew: {
        months: {
          narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "7"],
          short: ["ทิชรี", "เฮวาน", "กีสเลฟ", "เตเวต", "เชวัต", "อาดาร์ I", "อาดาร์", "นิสซาน", "อิยาร์", "สีวัน", "ตามูซ", "อัฟ", "เอลอุล", "อาดาร์ II"],
          long: ["ทิชรี", "เฮวาน", "กีสเลฟ", "เตเวต", "เชวัต", "อาดาร์ I", "อาดาร์", "นิสซาน", "อิยาร์", "สีวัน", "ตามูซ", "อัฟ", "เอลอุล", "อาดาร์ II"]
        },
        days: {
          narrow: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
          short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          long: ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"]
        },
        eras: {
          narrow: ["ย.ศ."],
          short: ["ย.ศ."],
          long: ["ย.ศ."]
        },
        dayPeriods: {
          am: "ก่อนเที่ยง",
          pm: "หลังเที่ยง"
        }
      },
      indian: {
        months: {
          narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
          short: ["จิตรา", "วิสาขา", "เชษฐา", "อัษฎา", "ศรวณา", "พัตรา", "อัศวิชา", "การติกา", "มฤคศิรา", "ปุษยา", "มาฆะ", "ผลคุณี"],
          long: ["จิตรา", "วิสาขา", "เชษฐา", "อัษฎา", "ศรวณา", "พัตรา", "อัศวิชา", "การติกา", "มฤคศิรา", "ปุษยา", "มาฆะ", "ผลคุณี"]
        },
        days: {
          narrow: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
          short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          long: ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"]
        },
        eras: {
          narrow: ["ม.ศ."],
          short: ["ม.ศ."],
          long: ["ม.ศ."]
        },
        dayPeriods: {
          am: "ก่อนเที่ยง",
          pm: "หลังเที่ยง"
        }
      },
      islamic: {
        months: {
          narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
          short: ["มุฮัร.", "เศาะ.", "รอบี I", "รอบี II", "จุมาดา I", "จุมาดา II", "เราะ.", "ชะอ์.", "เราะมะ.", "เชาว.", "ซุลกิอฺ.", "ซุลหิจ."],
          long: ["มุฮะร์รอม", "ซอฟาร์", "รอบี I", "รอบี II", "จุมาดา I", "จุมาดา II", "รอจับ", "ชะอะบาน", "รอมะดอน", "เชาวัล", "ซุลกิอฺดะฮฺ", "ซุลหิจญะฮฺ"]
        },
        days: {
          narrow: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
          short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          long: ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"]
        },
        eras: {
          narrow: ["ฮ.ศ."],
          short: ["ฮ.ศ."],
          long: ["ฮิจเราะห์ศักราช"]
        },
        dayPeriods: {
          am: "ก่อนเที่ยง",
          pm: "หลังเที่ยง"
        }
      },
      islamicc: {
        months: {
          narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
          short: ["มุฮัร.", "เศาะ.", "รอบี I", "รอบี II", "จุมาดา I", "จุมาดา II", "เราะ.", "ชะอ์.", "เราะมะ.", "เชาว.", "ซุลกิอฺ.", "ซุลหิจ."],
          long: ["มุฮะร์รอม", "ซอฟาร์", "รอบี I", "รอบี II", "จุมาดา I", "จุมาดา II", "รอจับ", "ชะอะบาน", "รอมะดอน", "เชาวัล", "ซุลกิอฺดะฮฺ", "ซุลหิจญะฮฺ"]
        },
        days: {
          narrow: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
          short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          long: ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"]
        },
        eras: {
          narrow: ["ฮ.ศ."],
          short: ["ฮ.ศ."],
          long: ["ฮิจเราะห์ศักราช"]
        },
        dayPeriods: {
          am: "ก่อนเที่ยง",
          pm: "หลังเที่ยง"
        }
      },
      japanese: {
        months: {
          narrow: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
          short: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
          long: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"]
        },
        days: {
          narrow: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
          short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          long: ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"]
        },
        eras: {
          narrow: ["Taika (645–650)", "Hakuchi (650–671)", "Hakuhō (672–686)", "Shuchō (686–701)", "Taihō (701–704)", "Keiun (704–708)", "Wadō (708–715)", "Reiki (715–717)", "Yōrō (717–724)", "Jinki (724–729)", "Tenpyō (729–749)", "Tenpyō-kampō (749-749)", "Tenpyō-shōhō (749-757)", "Tenpyō-hōji (757-765)", "Tenpyō-jingo (765-767)", "Jingo-keiun (767-770)", "Hōki (770–780)", "Ten-ō (781-782)", "Enryaku (782–806)", "Daidō (806–810)", "Kōnin (810–824)", "Tenchō (824–834)", "Jōwa (834–848)", "Kajō (848–851)", "Ninju (851–854)", "Saikō (854–857)", "Ten-an (857-859)", "Jōgan (859–877)", "Gangyō (877–885)", "Ninna (885–889)", "Kanpyō (889–898)", "Shōtai (898–901)", "Engi (901–923)", "Enchō (923–931)", "Jōhei (931–938)", "Tengyō (938–947)", "Tenryaku (947–957)", "Tentoku (957–961)", "Ōwa (961–964)", "Kōhō (964–968)", "Anna (968–970)", "Tenroku (970–973)", "Ten’en (973–976)", "Jōgen (976–978)", "Tengen (978–983)", "Eikan (983–985)", "Kanna (985–987)", "Eien (987–989)", "Eiso (989–990)", "Shōryaku (990–995)", "Chōtoku (995–999)", "Chōhō (999–1004)", "Kankō (1004–1012)", "Chōwa (1012–1017)", "Kannin (1017–1021)", "Jian (1021–1024)", "Manju (1024–1028)", "Chōgen (1028–1037)", "Chōryaku (1037–1040)", "Chōkyū (1040–1044)", "Kantoku (1044–1046)", "Eishō (1046–1053)", "Tengi (1053–1058)", "Kōhei (1058–1065)", "Jiryaku (1065–1069)", "Enkyū (1069–1074)", "Shōho (1074–1077)", "Shōryaku (1077–1081)", "Eihō (1081–1084)", "Ōtoku (1084–1087)", "Kanji (1087–1094)", "Kahō (1094–1096)", "Eichō (1096–1097)", "Jōtoku (1097–1099)", "Kōwa (1099–1104)", "Chōji (1104–1106)", "Kashō (1106–1108)", "Tennin (1108–1110)", "Ten-ei (1110-1113)", "Eikyū (1113–1118)", "Gen’ei (1118–1120)", "Hōan (1120–1124)", "Tenji (1124–1126)", "Daiji (1126–1131)", "Tenshō (1131–1132)", "Chōshō (1132–1135)", "Hōen (1135–1141)", "Eiji (1141–1142)", "Kōji (1142–1144)", "Ten’yō (1144–1145)", "Kyūan (1145–1151)", "Ninpei (1151–1154)", "Kyūju (1154–1156)", "Hōgen (1156–1159)", "Heiji (1159–1160)", "Eiryaku (1160–1161)", "Ōho (1161–1163)", "Chōkan (1163–1165)", "Eiman (1165–1166)", "Nin’an (1166–1169)", "Kaō (1169–1171)", "Shōan (1171–1175)", "Angen (1175–1177)", "Jishō (1177–1181)", "Yōwa (1181–1182)", "Juei (1182–1184)", "Genryaku (1184–1185)", "Bunji (1185–1190)", "Kenkyū (1190–1199)", "Shōji (1199–1201)", "Kennin (1201–1204)", "Genkyū (1204–1206)", "Ken’ei (1206–1207)", "Jōgen (1207–1211)", "Kenryaku (1211–1213)", "Kenpō (1213–1219)", "Jōkyū (1219–1222)", "Jōō (1222–1224)", "Gennin (1224–1225)", "Karoku (1225–1227)", "Antei (1227–1229)", "Kanki (1229–1232)", "Jōei (1232–1233)", "Tenpuku (1233–1234)", "Bunryaku (1234–1235)", "Katei (1235–1238)", "Ryakunin (1238–1239)", "En’ō (1239–1240)", "Ninji (1240–1243)", "Kangen (1243–1247)", "Hōji (1247–1249)", "Kenchō (1249–1256)", "Kōgen (1256–1257)", "Shōka (1257–1259)", "Shōgen (1259–1260)", "Bun’ō (1260–1261)", "Kōchō (1261–1264)", "Bun’ei (1264–1275)", "Kenji (1275–1278)", "Kōan (1278–1288)", "Shōō (1288–1293)", "Einin (1293–1299)", "Shōan (1299–1302)", "Kengen (1302–1303)", "Kagen (1303–1306)", "Tokuji (1306–1308)", "Enkyō (1308–1311)", "Ōchō (1311–1312)", "Shōwa (1312–1317)", "Bunpō (1317–1319)", "Genō (1319–1321)", "Genkō (1321–1324)", "Shōchū (1324–1326)", "Karyaku (1326–1329)", "Gentoku (1329–1331)", "Genkō (1331–1334)", "Kenmu (1334–1336)", "Engen (1336–1340)", "Kōkoku (1340–1346)", "Shōhei (1346–1370)", "Kentoku (1370–1372)", "Bunchū (1372–1375)", "Tenju (1375–1379)", "Kōryaku (1379–1381)", "Kōwa (1381–1384)", "Genchū (1384–1392)", "Meitoku (1384–1387)", "Kakei (1387–1389)", "Kōō (1389–1390)", "Meitoku (1390–1394)", "Ōei (1394–1428)", "Shōchō (1428–1429)", "Eikyō (1429–1441)", "Kakitsu (1441–1444)", "Bun’an (1444–1449)", "Hōtoku (1449–1452)", "Kyōtoku (1452–1455)", "Kōshō (1455–1457)", "Chōroku (1457–1460)", "Kanshō (1460–1466)", "Bunshō (1466–1467)", "Ōnin (1467–1469)", "Bunmei (1469–1487)", "Chōkyō (1487–1489)", "Entoku (1489–1492)", "Meiō (1492–1501)", "Bunki (1501–1504)", "Eishō (1504–1521)", "Taiei (1521–1528)", "Kyōroku (1528–1532)", "Tenbun (1532–1555)", "Kōji (1555–1558)", "Eiroku (1558–1570)", "Genki (1570–1573)", "Tenshō (1573–1592)", "Bunroku (1592–1596)", "Keichō (1596–1615)", "Genna (1615–1624)", "Kan’ei (1624–1644)", "Shōho (1644–1648)", "Keian (1648–1652)", "Jōō (1652–1655)", "Meireki (1655–1658)", "Manji (1658–1661)", "Kanbun (1661–1673)", "Enpō (1673–1681)", "Tenna (1681–1684)", "Jōkyō (1684–1688)", "Genroku (1688–1704)", "Hōei (1704–1711)", "Shōtoku (1711–1716)", "Kyōhō (1716–1736)", "Genbun (1736–1741)", "Kanpō (1741–1744)", "Enkyō (1744–1748)", "Kan’en (1748–1751)", "Hōreki (1751–1764)", "Meiwa (1764–1772)", "An’ei (1772–1781)", "Tenmei (1781–1789)", "Kansei (1789–1801)", "Kyōwa (1801–1804)", "Bunka (1804–1818)", "Bunsei (1818–1830)", "Tenpō (1830–1844)", "Kōka (1844–1848)", "Kaei (1848–1854)", "Ansei (1854–1860)", "Man’en (1860–1861)", "Bunkyū (1861–1864)", "Genji (1864–1865)", "Keiō (1865–1868)", "M", "T", "S", "H"],
          short: ["ทะอิกะ (645–650)", "ฮะกุชิ (650–671)", "ฮากุโฮ (672–686)", "ชุโช (686–701)", "ทะอิโฮ (701–704)", "เคอุง (704–708)", "วะโด (708–715)", "เรกิ (715–717)", "โยโร (717–724)", "จิงกิ (724–729)", "เท็มเพียว (729–749)", "เท็มเพียว-คัมโป (749-749)", "เท็มเพียว-โชโฮ (749-757)", "เท็มเพียว-โฮจิ (757-765)", "เท็มเพียว-จิงโงะ (765-767)", "จิงโงะ-เคอุง (767-770)", "โฮกิ (770–780)", "เท็นโอ (781–782)", "เอ็นเรียะกุ (782–806)", "ดะอิโด (806–810)", "โคนิง (810–824)", "เท็นโช (824–834)", "โชวะ (834–848)", "คะโจ (848–851)", "นินจุ (851–854)", "ซะอิโกะ (854–857)", "เท็นนัง (857–859)", "โจงัง (859–877)", "เก็งเก (877–885)", "นินนะ (885–889)", "คัมเพียว (889–898)", "โชตะอิ (898–901)", "เอ็งงิ (901–923)", "เอ็นโช (923–931)", "โชเฮ (931–938)", "เท็งเงียว (938–947)", "เท็นเรียะกุ (947–957)", "เท็นโตะกุ (957–961)", "โอวะ (961–964)", "โคโฮ (964–968)", "อันนะ (968–970)", "เท็นโระกุ (970–973)", "เท็นเอ็ง (973–976)", "โจเง็ง (976–978)", "เท็งเง็ง (978–983)", "เอกัง (983–985)", "คันนะ (985–987)", "เอเอ็ง (987–989)", "เอโซ (989–990)", "โชเรียะกุ (990–995)", "โชโตะกุ (995–999)", "โชโฮ (999–1004)", "คันโก (1004–1012)", "โชวะ (1012–1017)", "คันนิง (1017–1021)", "จิอัง (1021–1024)", "มันจุ (1024–1028)", "โชเง็ง (1028–1037)", "โชเรียะกุ (1037–1040)", "โชคีว (1040–1044)", "คันโตะกุ (1044–1046)", "เอโช (1046–1053)", "เท็งงิ (1053–1058)", "โคเฮ (1058–1065)", "จิเรียะกุ (1065–1069)", "เอ็งคีว (1069–1074)", "โชโฮ (1074–1077)", "โชเรียะกุ (1077–1081)", "เอโฮะ (1081–1084)", "โอโตะกุ (1084–1087)", "คันจิ (1087–1094)", "คะโฮะ (1094–1096)", "เอโช (1096–1097)", "โชโตะกุ (1097–1099)", "โควะ (1099–1104)", "โชจิ (1104–1106)", "คะโช (1106–1108)", "เท็นนิง (1108–1110)", "เท็นเอ (1110–1113)", "เอกีว (1113–1118)", "เก็นเอ (1118–1120)", "โฮะอัง (1120–1124)", "เท็นจิ (1124–1126)", "ดะอิจิ (1126–1131)", "เท็นโช (1131–1132)", "โชโช (1132–1135)", "โฮะเอ็ง (1135–1141)", "เอจิ (1141–1142)", "โคจิ (1142–1144)", "เท็นโย (1144–1145)", "คีวอัง (1145–1151)", "นิมเป (1151–1154)", "คีวจุ (1154–1156)", "โฮะเง็ง (1156–1159)", "เฮจิ (1159–1160)", "เอเรียะกุ (1160–1161)", "โอโฮ (1161–1163)", "โชกัง (1163–1165)", "เอมัง (1165–1166)", "นินอัง (1166–1169)", "คะโอ (1169–1171)", "โชอัง (1171–1175)", "อังเง็ง (1175–1177)", "จิโช (1177–1181)", "โยวะ (1181–1182)", "จุเอ (1182–1184)", "เก็นเรียะกุ (1184–1185)", "บุนจิ (1185–1190)", "เค็งกีว (1190–1199)", "โชจิ (1199–1201)", "เค็นนิง (1201–1204)", "เก็งกีว (1204–1206)", "เค็นเอ (1206–1207)", "โชเก็ง (1207–1211)", "เค็นเรียะกุ (1211–1213)", "เค็มโป (1213–1219)", "โชกีว (1219–1222)", "โจโอ (1222–1224)", "เก็นนิง (1224–1225)", "คะโระกุ (1225–1227)", "อันเต (1227–1229)", "คังกิ (1229–1232)", "โจเอ (1232–1233)", "เท็มปุกุ (1233–1234)", "บุนเรียะกุ (1234–1235)", "คะเต (1235–1238)", "เรียะกุนิง (1238–1239)", "เอ็นโอ (1239–1240)", "นินจิ (1240–1243)", "คังเง็ง (1243–1247)", "โฮจิ (1247–1249)", "เค็นโช (1249–1256)", "โคเง็ง (1256–1257)", "โชกะ (1257–1259)", "โชเง็ง (1259–1260)", "บุนโอ (1260–1261)", "โคโช (1261–1264)", "บุนเอ (1264–1275)", "เค็นจิ (1275–1278)", "โคอัง (1278–1288)", "โชโอ (1288–1293)", "เอนิง (1293–1299)", "โชอัง (1299–1302)", "เค็งเง็ง (1302–1303)", "คะเง็ง (1303–1306)", "โทะกุจิ (1306–1308)", "เอ็งเก (1308–1311)", "โอโช (1311–1312)", "โชวะ (1312–1317)", "บุมโป (1317–1319)", "เก็นโอ (1319–1321)", "เก็งเกียว (1321–1324)", "โชชู (1324–1326)", "คะเระกิ (1326–1329)", "เก็นโตะกุ (1329–1331)", "เก็งโก (1331–1334)", "เค็มมุ (1334–1336)", "เอ็งเง็ง (1336–1340)", "โคโกะกุ (1340–1346)", "โชเฮ (1346–1370)", "เค็นโตะกุ (1370–1372)", "บุนชู (1372–1375)", "เท็นจุ (1375–1379)", "โคเรียะกุ (1379–1381)", "โควะ (1381–1384)", "เก็นชู (1384–1392)", "เมโตะกุ (1384–1387)", "คะเค (1387–1389)", "โคโอ (1389–1390)", "เมโตะกุ (1390–1394)", "โอเอ (1394–1428)", "โชโช (1428–1429)", "เอเกียว (1429–1441)", "คะกิสึ (1441–1444)", "บุนอัง (1444–1449)", "โฮโตะกุ (1449–1452)", "เคียวโตะกุ (1452–1455)", "โคโช (1455–1457)", "โชโระกุ (1457–1460)", "คันโช (1460–1466)", "บุนโช (1466–1467)", "โอนิง (1467–1469)", "บุมเม (1469–1487)", "โชเกียว (1487–1489)", "เอ็นโตะกุ (1489–1492)", "เมโอ (1492–1501)", "บุงกิ (1501–1504)", "เอโช (1504–1521)", "ทะอิเอ (1521–1528)", "เคียวโระกุ (1528–1532)", "เท็มมน (1532–1555)", "โคจิ (1555–1558)", "เอโระกุ (1558–1570)", "เก็งกิ (1570–1573)", "เท็นโช (1573–1592)", "บุนโระกุ (1592–1596)", "เคโช (1596–1615)", "เก็งวะ (1615–1624)", "คันเอ (1624–1644)", "โชโฮ (1644–1648)", "เคอัง (1648–1652)", "โชโอ (1652–1655)", "เมเรียะกุ (1655–1658)", "มันจิ (1658–1661)", "คัมบุง (1661–1673)", "เอ็มโป (1673–1681)", "เท็นวะ (1681–1684)", "โจเกียว (1684–1688)", "เก็นโระกุ (1688–1704)", "โฮเอ (1704–1711)", "โชโตะกุ (1711–1716)", "เคียวโฮ (1716–1736)", "เก็มบุง (1736–1741)", "คัมโป (1741–1744)", "เอ็งเกียว (1744–1748)", "คันเอ็ง (1748–1751)", "โฮเรียะกุ (1751–1764)", "เมวะ (1764–1772)", "อันเอ (1772–1781)", "เท็มเม (1781–1789)", "คันเซ (1789–1801)", "เคียววะ (1801–1804)", "บุงกะ (1804–1818)", "บุนเซ (1818–1830)", "เท็มโป (1830–1844)", "โคกะ (1844–1848)", "คะเอ (1848–1854)", "อันเซ (1854–1860)", "มันเอ็ง (1860–1861)", "บุงกีว (1861–1864)", "เก็นจิ (1864–1865)", "เคโอ (1865–1868)", "เมจิ", "ทะอิโช", "โชวะ", "เฮเซ"],
          long: ["ทะอิกะ (645–650)", "ฮะกุชิ (650–671)", "ฮากุโฮ (672–686)", "ชุโช (686–701)", "ทะอิโฮ (701–704)", "เคอุง (704–708)", "วะโด (708–715)", "เรกิ (715–717)", "โยโร (717–724)", "จิงกิ (724–729)", "เท็มเพียว (729–749)", "เท็มเพียว-คัมโป (749-749)", "เท็มเพียว-โชโฮ (749-757)", "เท็มเพียว-โฮจิ (757-765)", "เท็มเพียว-จิงโงะ (765-767)", "จิงโงะ-เคอุง (767-770)", "โฮกิ (770–780)", "เท็นโอ (781–782)", "เอ็นเรียะกุ (782–806)", "ดะอิโด (806–810)", "โคนิง (810–824)", "เท็นโช (824–834)", "โชวะ (834–848)", "คะโจ (848–851)", "นินจุ (851–854)", "ซะอิโกะ (854–857)", "เท็นนัง (857–859)", "โจงัง (859–877)", "เก็งเก (877–885)", "นินนะ (885–889)", "คัมเพียว (889–898)", "โชตะอิ (898–901)", "เอ็งงิ (901–923)", "เอ็นโช (923–931)", "โชเฮ (931–938)", "เท็งเงียว (938–947)", "เท็นเรียะกุ (947–957)", "เท็นโตะกุ (957–961)", "โอวะ (961–964)", "โคโฮ (964–968)", "อันนะ (968–970)", "เท็นโระกุ (970–973)", "เท็นเอ็ง (973–976)", "โจเง็ง (976–978)", "เท็งเง็ง (978–983)", "เอกัง (983–985)", "คันนะ (985–987)", "เอเอ็ง (987–989)", "เอโซ (989–990)", "โชเรียะกุ (990–995)", "โชโตะกุ (995–999)", "โชโฮ (999–1004)", "คันโก (1004–1012)", "โชวะ (1012–1017)", "คันนิง (1017–1021)", "จิอัง (1021–1024)", "มันจุ (1024–1028)", "โชเง็ง (1028–1037)", "โชเรียะกุ (1037–1040)", "โชคีว (1040–1044)", "คันโตะกุ (1044–1046)", "เอโช (1046–1053)", "เท็งงิ (1053–1058)", "โคเฮ (1058–1065)", "จิเรียะกุ (1065–1069)", "เอ็งคีว (1069–1074)", "โชโฮ (1074–1077)", "โชเรียะกุ (1077–1081)", "เอโฮะ (1081–1084)", "โอโตะกุ (1084–1087)", "คันจิ (1087–1094)", "คะโฮะ (1094–1096)", "เอโช (1096–1097)", "โชโตะกุ (1097–1099)", "โควะ (1099–1104)", "โชจิ (1104–1106)", "คะโช (1106–1108)", "เท็นนิง (1108–1110)", "เท็นเอ (1110–1113)", "เอกีว (1113–1118)", "เก็นเอ (1118–1120)", "โฮะอัง (1120–1124)", "เท็นจิ (1124–1126)", "ดะอิจิ (1126–1131)", "เท็นโช (1131–1132)", "โชโช (1132–1135)", "โฮะเอ็ง (1135–1141)", "เอจิ (1141–1142)", "โคจิ (1142–1144)", "เท็นโย (1144–1145)", "คีวอัง (1145–1151)", "นิมเป (1151–1154)", "คีวจุ (1154–1156)", "โฮะเง็ง (1156–1159)", "เฮจิ (1159–1160)", "เอเรียะกุ (1160–1161)", "โอโฮ (1161–1163)", "โชกัง (1163–1165)", "เอมัง (1165–1166)", "นินอัง (1166–1169)", "คะโอ (1169–1171)", "โชอัง (1171–1175)", "อังเง็ง (1175–1177)", "จิโช (1177–1181)", "โยวะ (1181–1182)", "จุเอ (1182–1184)", "เก็นเรียะกุ (1184–1185)", "บุนจิ (1185–1190)", "เค็งกีว (1190–1199)", "โชจิ (1199–1201)", "เค็นนิง (1201–1204)", "เก็งกีว (1204–1206)", "เค็นเอ (1206–1207)", "โชเก็ง (1207–1211)", "เค็นเรียะกุ (1211–1213)", "เค็มโป (1213–1219)", "โชกีว (1219–1222)", "โจโอ (1222–1224)", "เก็นนิง (1224–1225)", "คะโระกุ (1225–1227)", "อันเต (1227–1229)", "คังกิ (1229–1232)", "โจเอ (1232–1233)", "เท็มปุกุ (1233–1234)", "บุนเรียะกุ (1234–1235)", "คะเต (1235–1238)", "เรียะกุนิง (1238–1239)", "เอ็นโอ (1239–1240)", "นินจิ (1240–1243)", "คังเง็ง (1243–1247)", "โฮจิ (1247–1249)", "เค็นโช (1249–1256)", "โคเง็ง (1256–1257)", "โชกะ (1257–1259)", "โชเง็ง (1259–1260)", "บุนโอ (1260–1261)", "โคโช (1261–1264)", "บุนเอ (1264–1275)", "เค็นจิ (1275–1278)", "โคอัง (1278–1288)", "โชโอ (1288–1293)", "เอนิง (1293–1299)", "โชอัง (1299–1302)", "เค็งเง็ง (1302–1303)", "คะเง็ง (1303–1306)", "โทะกุจิ (1306–1308)", "เอ็งเก (1308–1311)", "โอโช (1311–1312)", "โชวะ (1312–1317)", "บุมโป (1317–1319)", "เก็นโอ (1319–1321)", "เก็งเกียว (1321–1324)", "โชชู (1324–1326)", "คะเระกิ (1326–1329)", "เก็นโตะกุ (1329–1331)", "เก็งโก (1331–1334)", "เค็มมุ (1334–1336)", "เอ็งเง็ง (1336–1340)", "โคโกะกุ (1340–1346)", "โชเฮ (1346–1370)", "เค็นโตะกุ (1370–1372)", "บุนชู (1372–1375)", "เท็นจุ (1375–1379)", "โคเรียะกุ (1379–1381)", "โควะ (1381–1384)", "เก็นชู (1384–1392)", "เมโตะกุ (1384–1387)", "คะเค (1387–1389)", "โคโอ (1389–1390)", "เมโตะกุ (1390–1394)", "โอเอ (1394–1428)", "โชโช (1428–1429)", "เอเกียว (1429–1441)", "คะกิสึ (1441–1444)", "บุนอัง (1444–1449)", "โฮโตะกุ (1449–1452)", "เคียวโตะกุ (1452–1455)", "โคโช (1455–1457)", "โชโระกุ (1457–1460)", "คันโช (1460–1466)", "บุนโช (1466–1467)", "โอนิง (1467–1469)", "บุมเม (1469–1487)", "โชเกียว (1487–1489)", "เอ็นโตะกุ (1489–1492)", "เมโอ (1492–1501)", "บุงกิ (1501–1504)", "เอโช (1504–1521)", "ทะอิเอ (1521–1528)", "เคียวโระกุ (1528–1532)", "เท็มมน (1532–1555)", "โคจิ (1555–1558)", "เอโระกุ (1558–1570)", "เก็งกิ (1570–1573)", "เท็นโช (1573–1592)", "บุนโระกุ (1592–1596)", "เคโช (1596–1615)", "เก็งวะ (1615–1624)", "คันเอ (1624–1644)", "โชโฮ (1644–1648)", "เคอัง (1648–1652)", "โชโอ (1652–1655)", "เมเรียะกุ (1655–1658)", "มันจิ (1658–1661)", "คัมบุง (1661–1673)", "เอ็มโป (1673–1681)", "เท็นวะ (1681–1684)", "โจเกียว (1684–1688)", "เก็นโระกุ (1688–1704)", "โฮเอ (1704–1711)", "โชโตะกุ (1711–1716)", "เคียวโฮ (1716–1736)", "เก็มบุง (1736–1741)", "คัมโป (1741–1744)", "เอ็งเกียว (1744–1748)", "คันเอ็ง (1748–1751)", "โฮเรียะกุ (1751–1764)", "เมวะ (1764–1772)", "อันเอ (1772–1781)", "เท็มเม (1781–1789)", "คันเซ (1789–1801)", "เคียววะ (1801–1804)", "บุงกะ (1804–1818)", "บุนเซ (1818–1830)", "เท็มโป (1830–1844)", "โคกะ (1844–1848)", "คะเอ (1848–1854)", "อันเซ (1854–1860)", "มันเอ็ง (1860–1861)", "บุงกีว (1861–1864)", "เก็นจิ (1864–1865)", "เคโอ (1865–1868)", "เมจิ", "ทะอิโช", "โชวะ", "เฮเซ"]
        },
        dayPeriods: {
          am: "ก่อนเที่ยง",
          pm: "หลังเที่ยง"
        }
      },
      persian: {
        months: {
          narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
          short: ["ฟาร์วาร์ดิน", "ออร์ดิเบเฮชต์", "คอร์แดด", "เตอร์", "มอร์แดด", "ชาหริวาร์", "เมฮร์", "อะบาน", "อะซาร์", "เดย์", "บาฮ์มาน", "เอสฟานด์"],
          long: ["ฟาร์วาร์ดิน", "ออร์ดิเบเฮชต์", "คอร์แดด", "เตอร์", "มอร์แดด", "ชาหริวาร์", "เมฮร์", "อะบาน", "อะซาร์", "เดย์", "บาฮ์มาน", "เอสฟานด์"]
        },
        days: {
          narrow: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
          short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          long: ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"]
        },
        eras: {
          narrow: ["ปีเปอร์เซีย"],
          short: ["ปีเปอร์เซีย"],
          long: ["ปีเปอร์เซีย"]
        },
        dayPeriods: {
          am: "ก่อนเที่ยง",
          pm: "หลังเที่ยง"
        }
      },
      roc: {
        months: {
          narrow: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
          short: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
          long: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"]
        },
        days: {
          narrow: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
          short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          long: ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"]
        },
        eras: {
          narrow: ["ปีก่อนไต้หวัน", "ไต้หวัน"],
          short: ["ปีก่อนไต้หวัน", "ไต้หวัน"],
          long: ["ปีก่อนไต้หวัน", "ไต้หวัน"]
        },
        dayPeriods: {
          am: "ก่อนเที่ยง",
          pm: "หลังเที่ยง"
        }
      }
    }
  },
  number: {
    nu: ["latn"],
    patterns: {
      decimal: {
        positivePattern: "{number}",
        negativePattern: "{minusSign}{number}"
      },
      currency: {
        positivePattern: "{currency}{number}",
        negativePattern: "{minusSign}{currency}{number}"
      },
      percent: {
        positivePattern: "{number}{percentSign}",
        negativePattern: "{minusSign}{number}{percentSign}"
      }
    },
    symbols: {
      latn: {
        decimal: ".",
        group: ",",
        nan: "NaN",
        plusSign: "+",
        minusSign: "-",
        percentSign: "%",
        infinity: "∞"
      },
      thai: {
        decimal: ".",
        group: ",",
        nan: "NaN",
        plusSign: "+",
        minusSign: "-",
        percentSign: "%",
        infinity: "∞"
      }
    },
    currencies: {
      AUD: "AU$",
      BRL: "R$",
      CAD: "CA$",
      CNY: "CN¥",
      EUR: "€",
      GBP: "£",
      HKD: "HK$",
      ILS: "₪",
      INR: "₹",
      JPY: "¥",
      KRW: "₩",
      MXN: "MX$",
      NZD: "NZ$",
      TWD: "NT$",
      USD: "US$",
      VND: "₫",
      XAF: "FCFA",
      XCD: "EC$",
      XOF: "CFA",
      XPF: "CFPF"
    }
  }
});